// Trefferbewertung: höher = genauer.
const SCORE_FULL_NAME_EXACT = 1000;
const SCORE_FULL_NAME_PREFIX = 800;
const SCORE_SINGLE_NAME_EXACT = 700;
const SCORE_SINGLE_NAME_PREFIX = 650;
const SCORE_FULL_NAME_CONTAINS = 500;
const SCORE_SINGLE_NAME_CONTAINS = 450;

type ScorablePerson = {
  firstName?: string | null;
  lastName?: string | null;
};

/** Vergleichsform eines Suchbegriffs oder Namensteils. */
export function normalizeSearchTerm(value: string | null | undefined): string {
  return (value || "").trim().toLowerCase();
}

/**
 * Trefferbewertung einer Person zu einem Suchbegriff, absteigend nach Genauigkeit:
 * vollständiger Name, Namensanfang, einzelner Name, Namensteil.
 *
 * Einzige Quelle für alle Masken, die Personen suchen — sonst führt derselbe Suchbegriff je nach
 * Einstiegspunkt zu einer anderen Trefferreihenfolge.
 */
export function scorePerson(person: ScorablePerson, term: string): number {
  const t = normalizeSearchTerm(term);
  if (!t) return 0;

  const firstName = normalizeSearchTerm(person.firstName);
  const lastName = normalizeSearchTerm(person.lastName);
  const full = [firstName, lastName].filter(Boolean).join(" ");
  const fullReversed = [lastName, firstName].filter(Boolean).join(" ");

  if (full === t || fullReversed === t) return SCORE_FULL_NAME_EXACT;
  if (full.startsWith(t) || fullReversed.startsWith(t)) return SCORE_FULL_NAME_PREFIX;
  if (lastName === t || firstName === t) return SCORE_SINGLE_NAME_EXACT;
  if (lastName.startsWith(t) || firstName.startsWith(t)) return SCORE_SINGLE_NAME_PREFIX;
  if (full.includes(t) || fullReversed.includes(t)) return SCORE_FULL_NAME_CONTAINS;
  if (lastName.includes(t) || firstName.includes(t)) return SCORE_SINGLE_NAME_CONTAINS;
  return 0;
}

/** Trefferliste nach Bewertung sortiert; die Eingabeliste bleibt unverändert. */
export function sortPersonsByScore<T extends ScorablePerson>(list: T[] | null | undefined, term: string): T[] {
  return [...(list || [])].sort((a, b) => scorePerson(b, term) - scorePerson(a, term));
}
